<template>
  <div>
    <cursoHeader></cursoHeader>
    <div class="bg-white border border-gray my2 px2">
      <ul>
        <li
          v-for="(record, index) in leis"
          :key="index"
        >
          <h2 class="m1">{{record.LEI}}</h2>
          <ul
            class="list-reset"
            v-for="(item, index) in record.DESCRICOES"
            :key="index"
          >
            <li
              class="h3"
              v-show="linha.CONTEUDO"
              v-for="(linha, index) in item.LINHAS"
              :key="index"
            >
              {{linha.CONTEUDO}}
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <menuBotoes></menuBotoes>
  </div>
</template>

<script>
import cursoHeader from '@/custom/cursoHeader'
import menuBotoes from '@/custom/menuBotoes'
var componentDefinition = {
  components: { cursoHeader, menuBotoes },
  route: {
    name: 'DISPOSITIVOSLEGAIS',
    path: '/aluno/:idaluno/matricula/:idmatricula/bloco/:idbloco/dispositivoslegais/:debug?',
    meta: {
      title: 'Dispositivos Legais',
      hidden: true
    }
  },
  computed: {
    leis: function () {
      var leis = []
      var idlei = 0
      if (this.$dados.DISPOSITIVOSLEGAIS.records) {
        this.$dados.DISPOSITIVOSLEGAIS.records.map(record => {
          if (record.IDLEI !== idlei) {
            leis.push({
              LEI: record.LEI,
              DESCRICOES: []
            })
          }
          idlei = record.IDLEI
          var lei = leis[leis.length - 1]
          lei.DESCRICOES.push({
            DESCRICAO: record.DESCRICAO,
            LINHAS: record.LINHAS
          })
        })
      }
      return leis
    }
  }
}
export default componentDefinition
</script>
